import { useEffect } from 'react';
import BreedServices from '../components/BreedServices';
import NewsLetter from '../components/NewsLetter';
import ShopAll from '../components/ourshop/Shopall';
import BreadCumbcat from '../components/shop/BreadCumb';


function Shop() {
useEffect(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });
}, []);
	return (
		<main>
			<BreadCumbcat/>
			<ShopAll />
			<BreedServices />
			<NewsLetter />
		</main>
	)
}

export default Shop;
